<svg:g [style.opacity]="caliper.opacity">

  <g caliper-window id="window" [window]="caliper.window" [measures]="measures" (removeClicked)="onRemoveCaliper()" (positionChange)="onPositionChange($event)"></g>

  <g trace-pointer [pointer]="caliper.pointer1" (intersectionChange)="onPointer1IntersectionChange()"></g>
  <g trace-pointer [pointer]="caliper.pointer2" (intersectionChange)="onPointer2IntersectionChange()"></g>

  <!--<g trace-measure [measure]="caliper.measure"></g>-->
</svg:g>
